import React, { useEffect, useState } from "react";
import CommonFormBuilder from "../../CommonComponenets/FormBuilder";
import DryNeedling from "./DryNeedling";
import WallClimbing from "./WallClimbing";
import MMTForm from "../../PT/components/MMTForm";
import TUG from "./TUGForm";
import MASForm from "./MASForm";
import SARAForm from "./SARAForm";
import BergBalanceScale from "./BBS";
import FimAssessment from "./Fim";
import TISAssessment from "./TsiAssessment";
import ROMForm from "./RomForm";
import IADLAssessment from "./IADL";
import MoCAAssessment from "./MocA";
import PatientCard from "../../../shared/cards/PatientCard";

export const NEURO_ASSESSMENT_REGISTRY = {
  mmt: MMTForm,
  tug: TUG,
  mas: MASForm,
  sara: SARAForm,
  bbs: BergBalanceScale,
  fim: FimAssessment,
  flug: IADLAssessment,
  tsi: TISAssessment,
  rom: ROMForm,
  moca: MoCAAssessment
};

/* ===================== OPTIONS ===================== */
// ADD STATE near other useState
const YES_NO = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];
const Static_Dynamic = [
  { label: "Static", value: "static" },
  { label: "Dynamic", value: "dynamic" }
];
const Functional_assessment = [
  { label: "Independent", value: "independent" },
  { label: "Supervision", value: "supervision" },
  { label: "Minimal Assistance", value: "mia" },
  { label: "Moderate Assistance", value: "moa" },
  { label: "Maximal Assistance", value: "maa" },
  { label: "Dependent", value: "dependent" },
  { label: "Not Assessed / NotApplicable", value: "NA" },

];
const PROGNOSIS_OPTIONS = [
  { label: "Excellent", value: "excellent" },
  { label: "Good", value: "good" },
  { label: "Fair", value: "fair" },
  { label: "Poor", value: "poor" }
];

const AMBULATORY_OPTIONS = [
  { label: "Independent walking", value: "independent" },
  { label: "Wheelchair", value: "wheelchair" },
  { label: "Quadripod narrowbase", value: "Quadripodnarrowbase" },
  { label: "Quadripod wide base", value: "Quadripodwidebase" },
  { label: "Walking stick", value: "stick" },
  { label: "Walking frame", value: "frame" },
  { label: "Elbow crutches", value: "crutches" },
  { label: "Others", value: "others" }
];
// const PATIENT_ENVIRONMENT_SCHEMA = {
//   title: "Patient Environment",
//   sections: [
//     {
//       fields: [

//         /* ================= EQUIPMENT OWNED ================= */
//         {
//           name: "equipment_owned",
//           label: "List of Equipment Owned",
//           type: "checkbox-group",
//           options: [
//             { label: "PERKESO", value: "perkeso" },
//             { label: "NGO", value: "ngo" },
//             { label: "Self-purchased", value: "self" },
//             { label: "Others", value: "others" }
//           ]
//         },

//         /* ===== CONDITIONAL TEXT AREAS ===== */
//         {
//           name: "equipment_perkeso",
//           label: "PERKESO Equipment Details",
//           type: "input",
//           showIf: { field: "equipment_owned", includes: "perkeso" }
//         },
//         {
//           name: "equipment_ngo",
//           label: "NGO Equipment Details",
//           type: "input",
//  showIf: { field: "equipment_owned", includes: "ngo" }
//         },
//         {
//           name: "equipment_self",
//           label: "Self-purchased Equipment Details",
//           type: "input",
//  showIf: { field: "equipment_owned", includes: "self" }
//         },
//         {
//           name: "equipment_others",
//           label: "Other Equipment Details",
//           type: "input",
//  showIf: { field: "equipment_owned", includes: "others" }
//         },

//         /* ================= HOME ENVIRONMENT ================= */
//         {
//           name: "home_environment",
//           label: "Home Environment",
//           type: "input"
//         },

//         /* ================= TYPE OF HOUSE ================= */
//         {
//           name: "house_type",
//           label: "Type of House",
//           type: "single-select",
//           options: [
//             { label: "Single-storey", value: "single" },
//             { label: "Double-storey", value: "double" },
//             { label: "Apartment with elevator", value: "apartment" },
//             { label: "Others", value: "others" }
//           ]
//         },
//         {
//           name: "house_type_other",
//           label: "If Others, specify",
//           type: "input",
//           showIf: { field: "house_type", equals: "others" }
//         },

//         /* ================= TYPE OF TOILET ================= */
//         {
//           name: "toilet_type",
//           label: "Toilet Type",
//           type: "checkbox-group",
//           options: [
//             { label: "Sitting", value: "sitting" },
//             { label: "Squatting", value: "squatting" }
//           ]
//         },

//         /* ================= EDUCATION LEVEL ================= */
//         {
//           name: "education_level",
//           label: "Education Level",
//           type: "single-select",
//           options: [
//             { label: "Primary", value: "primary" },
//             { label: "Secondary", value: "secondary" },
//             { label: "Diploma", value: "diploma" },
//             { label: "Degree", value: "degree" },
//             { label: "Master", value: "master" },
//             { label: "PhD", value: "phd" },
//             { label: "Others", value: "others" }
//           ]
//         },
//         {
//           name: "education_other",
//           label: "If Others, specify",
//           type: "input",
//           showIf: { field: "education_level", equals: "others" }
//         }

//       ]
//     }
//   ]
// };


export default function AmputeeAssessment({ patient, onSubmit, onBack }) {
  const [values, setValues] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("subjective");
  const [showConsentModal, setShowConsentModal] = useState(false);
  // Live consent form values — updated on every field change inside the modal
  const [dryNeedlingValues,  setDryNeedlingValues]  = useState({});
  const [wallClimbingValues, setWallClimbingValues] = useState({});
  // Refs hold the absolute latest values without causing re-renders
  const dryNeedlingRef  = React.useRef({});
  const wallClimbingRef = React.useRef({});

  /* ---------------- STORAGE ---------------- */
  const storageKey = patient
    ? `amputee_assessment_draft_${patient.id}`
    : null;

  useEffect(() => {
    if (!storageKey) return;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      setValues(JSON.parse(saved).values || {});
    }
  }, [storageKey]);
  useEffect(() => {
    if (!patient) return;

    setValues(v => ({
      ...v,
      pmh_from_registration:
        patient.medical_history || "No data available",

      family_social_from_registration:
        patient.diagnosis_history || "No data available"
    }));
  }, [patient]);

  const onChange = (name, value) => {
    setValues(v => ({ ...v, [name]: value }));

    // auto open modal when consent selected from dropdown
    if (name === "consent_obtained" && value && value !== values.consent_obtained) {
      setShowConsentModal(true);
    }

    // open modal when "Open Saved Consent" button clicked inside schema
    if (name === "_open_consent_trigger" && value) {
      setValues(v => ({ ...v, consent_obtained: value }));
      setShowConsentModal(true);
    }
  };

  const handleAction = (type) => {
    if (type === "back") onBack?.();
    if (type === "clear") {
      setValues({});
      setSubmitted(false);
      localStorage.removeItem(storageKey);
    }
    if (type === "save") {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ values, updatedAt: new Date() })
      );
      alert("Neuro draft saved");
    }
  };

  const handleSubmit = () => {
    setSubmitted(true);
    onSubmit?.(values);
    alert("Neuro assessment submitted");
  };

  /* ===================== SCHEMAS ===================== */
const SUBJECTIVE_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        { type: "subheading", label: "Chief Complaint & History" },
        { type: "input", name: "chief_complaint", label: "Chief Complaint" },
        { type: "input", name: "history_present_illness", label: "History of Present Illness" },
        { type: "subheading", label: "Social & Personal History" },
        { type: "input", name: "work_history", label: "Work History" },
        { type: "input", name: "client_expectations", label: "Client Expectations" },
        { type: "input", name: "driving_history", label: "Driving History" },

        { type: "subheading", label: "Driving Details" },
        {
          type: "single-select",
          name: "driving_license_type",
          label: "Driving License Type",
          options: [
            { label: "None", value: "None" },
            { label: "B2 – Motor Car (Private Vehicle)", value: "B2" },
            { label: "D – Heavy Motor Vehicle", value: "D" },
            { label: "E – Heavy Trailer Vehicle", value: "E" },
            { label: "GDL – Goods Driving License", value: "GDL" },
            { label: "PSV – Public Service Vehicle", value: "PSV" },
            { label: "Other", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "driving_license_other",
          label: "Please specify",
          showIf: { field: "driving_license_type", equals: "Other" }
        },
        { type: "radio", name: "returned_to_driving", label: "Returned to Drive Post Injury?", options: ["Yes", "No"] },
        {
          type: "input",
          name: "driving_duration_distance",
          label: "If Yes – Duration & Distance",
          showIf: { field: "returned_to_driving", equals: "Yes" }
        }
      ]
    }
  ]
};
// ...existing code...

const CONSENT_AND_REFERRAL_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        {
          type: "row",
          fields: [
            {
              name: "consent_obtained",
              label: "Consent",
              type: "single-select",
              options: [
                { label: "Dry Needling",   value: "dry_needling"   },
                { label: "Wall Climbing",  value: "wall_climbing"  }
              ]
            },
          ]
        },
        /* ── Open Saved Consent — injected via custom render ── */
        {
          type: "custom",
          name: "_open_saved_consent",
          render: ({ values, onChange: _onChange }) => {
            const hasDry  = !!values.dry_needling_consent;
            const hasWall = !!values.wall_climbing_consent;
            if (!hasDry && !hasWall) return null;
            return (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: "#0F172A", marginBottom: 8 }}>
                  Open Saved Consent
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {hasDry && (
                    <button
                      type="button"
                      style={savedBtn}
                      onClick={() => _onChange("_open_consent_trigger", "dry_needling")}
                    >
                      Open Dry Needling Consent
                    </button>
                  )}
                  {hasWall && (
                    <button
                      type="button"
                      style={savedBtn}
                      onClick={() => _onChange("_open_consent_trigger", "wall_climbing")}
                    >
                      Open Wall Climbing Consent
                    </button>
                  )}
                </div>
              </div>
            );
          }
        },
        {
          name: "hep_reviewed",
          type: "checkbox-group",
          options: [{ label: "Home Exercise Program (HEP) reviewed and demonstrated", value: "yes" }]
        },
        {
          name: "current_diagnosis",
          label: "Current Diagnosis",
          type: "multi-select-dropdown",
          options: [
            { label: "Stroke", value: "stroke" },
            { label: "Traumatic Brain Injury", value: "tbi" },
            { label: "Parkinson Disease", value: "parkinson" },
            { label: "Spinal Cord Injury", value: "sci" },
            { label: "Peripheral Neuropathy", value: "peripheral_neuropathy" },
            { label: "Ligament injuries", value: "ligament_injuries" },
            { label: "Ataxia", value: "ataxia" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "current_diagnosis_other",
          label: "Other Diagnosis (specify)",
          type: "input",
          showIf: { field: "current_diagnosis", includes: "others" }
        },
        {
          name: "equipment_owned",
          label: "List of Equipment Owned",
          type: "checkbox-group",
          options: [
            { label: "PERKESO", value: "perkeso" },
            { label: "NGO", value: "ngo" },
            { label: "Self-purchased", value: "self" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "equipment_perkeso",
          label: "PERKESO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "perkeso" }
        },
        {
          name: "equipment_ngo",
          label: "NGO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "ngo" }
        },
        {
          name: "equipment_self",
          label: "Self-purchased Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "self" }
        },
        {
          name: "equipment_others",
          label: "Other Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "others" }
        }
        ,
        { type: "subheading", label: "Referral Information" },
        {
          name: "referred_by",
          label: "Referred by",
          type: "input",
          readOnly: true
        },
        {
          name: "referral_reasons",
          label: "Referral Reasons",
          type: "input",
          readOnly: true
        }
      ]
    }
  ]
};

  const NEURO_CONTAINER_SCHEMA = {
    title: "Patient Information",
    sections: [

    ]
  };


const OBJECTIVE_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        { type: "subheading", label: "Physical Status" },
        {
          name: "neuro_scales",
          type: "assessment-launcher",
          options: [
            { label: "Range of Motion (ROM)", value: "rom" },
            { label: "Manual Muscle Test (MMT)", value: "mmt" },
            { label: "Functional Independence Measure (FIM)", value: "fim" },
            { label: "Lawton IADL", value: "flug" },
            { label: "Montreal Cognitive Assessment (MoCA)", value: "moca" }
          ]
        },
        { type: "radio", name: "dominant_side", label: "Dominant", options: ["Right", "Left"] },
        {
          type: "checkbox-group",
          name: "affected_side",
          label: "Affected",
          position: "side",
          options: [
            { label: "Left UE", value: "LUE" },
            { label: "Right UE", value: "RUE" },
            { label: "Left LE", value: "LLE" },
            { label: "Right LE", value: "RLE" }
          ]
        },

        { type: "subheading", label: "Stump / Skin Condition" },
        { type: "radio", name: "wound_status", label: "Wound", options: ["Nil", "Present"] },
        {
          type: "input",
          name: "wound_details",
          label: "Wound Details",
          showIf: { field: "wound_status", equals: "Present" }
        },
        {
          type: "single-select",
          name: "muscle_condition",
          label: "Muscle",
          position: "side",
          options: [
            { label: "Firm", value: "Firm" },
            { label: "Flabby", value: "Flabby" },
            { label: "Atrophied", value: "Atrophied" },
            { label: "Others", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "muscle_condition_other",
          label: "Please specify",
          placeholder: "Enter muscle condition",
          position: "side",
          showIf: { field: "muscle_condition", equals: "Other" }
        },
        { type: "radio", name: "edema", label: "Edema", options: ["Nil", "Present"] },
        { type: "input", name: "edema_grade", label: "Grade / Measurement" },
        {
          type: "radio",
          name: "skin_condition",
          label: "Skin",
          position: "side",
          options: [
            { label: "Normal", value: "Normal" },
            { label: "Dry", value: "Dry" },
            { label: "Fragile", value: "Fragile" },
            { label: "Discoloured", value: "Discoloured" },
            { label: "Breakdown", value: "Breakdown" }
          ]
        },
        {
          type: "radio",
          name: "scar_type",
          label: "Scar",
          position: "side",
          options: [
            { label: "Matured", value: "Matured" },
            { label: "Adhered", value: "Adhered" },
            { label: "Hypertrophic", value: "Hypertrophic" },
            { label: "Keloid", value: "Keloid" }
          ]
        },
        {
          type: "radio",
          name: "stump_shape",
          label: "Shape",
          position: "side",
          options: [
            { label: "Conical", value: "Conical" },
            { label: "Cylindrical", value: "Cylindrical" },
            { label: "Bulbous", value: "Bulbous" }
          ]
        },

        { type: "subheading", label: "Sensation / Pain (Residual Limb)" },
        { type: "radio", name: "phantom_sensation", label: "Phantom Sensation", options: ["Nil", "Sometimes", "Present", "Absent"] },
        { type: "radio", name: "phantom_pain", label: "Phantom Pain", options: ["Nil", "Sometimes", "Present", "Absent"] },
        {
          type: "scale-slider",
          name: "phantom_vas",
          label: "Phantom Pain VAS (0–10)",
          min: 0,
          max: 10,
          step: 1,
          showValue: true,
          ranges: [
            { min: 0, max: 3, color: "#16a34a", label: "Mild" },
            { min: 4, max: 6, color: "#f59e0b", label: "Moderate" },
            { min: 7, max: 10, color: "#dc2626", label: "Severe" }
          ]
        },
        { type: "radio", name: "stump_pain", label: "Stump Pain", options: ["Nil", "Sometimes", "Present", "Absent"] },
        {
          type: "scale-slider",
          name: "stump_vas",
          label: "Stump Pain VAS (0–10)",
          min: 0,
          max: 10,
          step: 1,
          showValue: true,
          ranges: [
            { min: 0, max: 3, color: "#16a34a", label: "Mild" },
            { min: 4, max: 6, color: "#f59e0b", label: "Moderate" },
            { min: 7, max: 10, color: "#dc2626", label: "Severe" }
          ]
        },
        { type: "radio", name: "hypersensitivity", label: "Hypersensitivity", options: ["Nil", "Yes"] },
        { type: "radio", name: "light_touch", label: "Light Touch", options: ["Intact", "Impaired"] },
        { type: "radio", name: "deep_touch", label: "Deep Touch", options: ["Intact", "Impaired"] },
        { type: "input", name: "semmes_weinstein", label: "Semmes Weinstein (if applicable)" },

        { type: "subheading", label: "Mobility & Ambulation" },
        {
          type: "single-select",
          name: "short_distance",
          label: "Short Distance",
          options: [
            { label: "Independent Walking", value: "Independent" },
            { label: "Wheelchair", value: "Wheelchair" },
            { label: "Quadripod Narrow Base", value: "QuadNarrow" },
            { label: "Quadripod Wide Base", value: "QuadWide" },
            { label: "Walking Stick", value: "Stick" },
            { label: "Walking Frame", value: "Frame" },
            { label: "Elbow Crutches", value: "ElbowCrutches" },
            { label: "Axillary Crutches", value: "Axillary" },
            { label: "Others", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "short_distance_other",
          label: "Please specify (Short Distance)",
          showIf: { field: "short_distance", equals: "Other" }
        },
        {
          type: "single-select",
          name: "long_distance",
          label: "Long Distance",
          options: [
            { label: "Independent Walking", value: "Independent" },
            { label: "Wheelchair", value: "Wheelchair" },
            { label: "Quadripod Narrow Base", value: "QuadNarrow" },
            { label: "Walking Stick", value: "Stick" },
            { label: "Walking Frame", value: "Frame" },
            { label: "Elbow Crutches", value: "ElbowCrutches" },
            { label: "Others", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "long_distance_other",
          label: "Please specify (Long Distance)",
          placeholder: "Enter walking aid",
          showIf: { field: "long_distance", equals: "Other" }
        },

        { type: "subheading", label: "Transfer" },
        {
          type: "single-select",
          name: "bed_chair_transfer",
          label: "Bed ↔ Chair",
          options: [
            { label: "Independent", value: "Independent" },
            { label: "Supervision", value: "Supervision" },
            { label: "Minimal Assistance", value: "MinA" },
            { label: "Moderate Assistance", value: "ModA" },
            { label: "Max Assistance", value: "MaxA" }
          ]
        },
        {
          type: "radio",
          name: "toilet_transfer",
          label: "Toilet Transfer",
          options: [
            { label: "Independent", value: "Independent" },
            { label: "Assistance", value: "Assistance" }
          ]
        },
        { type: "input", name: "car_transfer", label: "Car Transfer (with/without prosthesis)" },

        { type: "subheading", label: "Standing Tolerance" },
        { type: "input", name: "standing_duration", label: "Standing Duration (minutes)" },
        { type: "radio", name: "standing_status", label: "Standing Status", options: ["Independent", "Requires Support", "Unable"] },
        { type: "input", name: "standing_observation", label: "Observation" },

        { type: "subheading", label: "Balance Testing" },
        {
          type: "grid-table-flat",
          name: "balance_table",
          headers: ["Without Prosthesis", "With Prosthesis"],
          rows: [
            { key: "sit_static", label: "Sitting – Static" },
            { key: "sit_dynamic", label: "Sitting – Dynamic" },
            { key: "stand_static", label: "Standing – Static" },
            { key: "stand_dynamic", label: "Standing – Dynamic" }
          ]
        },

        { type: "subheading", label: "Strength Testing (Jamar Dynamometer)" },
        {
          type: "grid-table-flat",
          name: "jamar_table",
          headers: ["Right (KGF)", "Left (KGF)"],
          rows: [
            { key: "grip", label: "Grip" },
            { key: "tip", label: "Tip" },
            { key: "lateral", label: "Lateral" },
            { key: "tripod", label: "Tripod" }
          ]
        }
      ]
    }
  ]
};

const ASSESSMENT_SCHEMA = {
  title: "Assessment",
  sections: [
    {
      fields: [
        { type: "subheading", label: "Problem List" },
        { type: "input", name: "problem_list", label: "Problem List" },

        { type: "subheading", label: "Functional Limitations" },
        {
          type: "single-select",
          name: "functional_limitations",
          label: "Select Functional Limitations",
          options: [
            { label: "Gait Impairment", value: "Gait" },
            { label: "Unsafe Transfers", value: "Transfers" },
            { label: "Prosthesis-related Issues", value: "Prosthesis" },
            { label: "Pain & Sensory Issues", value: "PainSensory" },
            { label: "Balance & Postural Control", value: "Balance" },
            { label: "Others", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "functional_limitations_other",
          label: "Others, Specify",
          showIf: { field: "functional_limitations", equals: "Other" }
        },

        { type: "subheading", label: "Underlying Cause" },
        {
          type: "single-select",
          name: "underlying_cause",
          label: "Select Underlying Cause",
          options: [
            { label: "Diabetes Mellitus", value: "DM" },
            { label: "Peripheral Vascular Disease", value: "PVD" },
            { label: "Trauma", value: "Trauma" },
            { label: "Infection", value: "Infection" },
            { label: "Tumor", value: "Tumor" },
            { label: "Others", value: "Other" }
          ]
        },
        {
          type: "input",
          name: "underlying_cause_other",
          label: "Others, Specify",
          showIf: { field: "underlying_cause", equals: "Other" }
        },

        { type: "subheading", label: "Clinical Impression" },
        { type: "input", name: "clinical_impression", label: "Clinical Impression" },

        { type: "subheading", label: "Rehabilitation Prognosis" },
        { type: "radio", name: "rehab_prognosis", label: "Select Prognosis", options: ["Excellent", "Good", "Fair", "Poor"] }
      ]
    }
  ]
};

const PLAN_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        { type: "subheading", label: "Short Term Goals (2–4 Weeks)" },
        { type: "dynamic-goals", name: "short_term_goals" },

        { type: "subheading", label: "Long Term Goals (6–12 Weeks)" },
        { type: "dynamic-goals", name: "long_term_goals" },

       {
  type: "checkbox-group",
  name: "intervention_plan",
  label: "Intervention Plan",
  options: [
    { label: "Functional Endurance", value: "FunctionalEndurance" },
    { label: "Functional Balance", value: "FunctionalBalance" },
    { label: "Wheelchair training", value: "WheelchairTraining" },
    { label: "Education", value: "Education" },
    { label: "Community Reintegration", value: "CommunityReintegration" },
    { label: "Driving Assessment", value: "DrivingAssessment" },
    { label: "Riding Assessment", value: "RidingAssessment" }
  ]
},

{ type: "subheading", label: "ADL Training" },
{
  type: "checkbox-group",
  name: "adl_training",
  label: "",
  options: [
    { label: "Dressing", value: "Dressing" },
    { label: "Bathing", value: "Bathing" },
    { label: "Feeding", value: "Feeding" },
    { label: "Grooming", value: "Grooming" },
    { label: "Transfers", value: "Transfers" },
    { label: "Locomotion", value: "Locomotion" }
  ]
},

{ type: "subheading", label: "IADL Training" },
{
  type: "checkbox-group",
  name: "iadl_training",
  label: "",
  options: [
    { label: "Telephoning", value: "Telephoning" },
    { label: "Shopping", value: "Shopping" },
    { label: "Food Preparation", value: "FoodPreparation" },
    { label: "Housekeeping", value: "Housekeeping" },
    { label: "Laundry", value: "Laundry" },
    { label: "Mode of transportation", value: "ModeOfTransportation" },
    { label: "Medication management", value: "MedicationManagement" },
    { label: "Money management", value: "MoneyManagement" }
  ]
},

{ type: "subheading", label: "Driving / Riding Rehab" },
{
  type: "checkbox-group",
  name: "driving_riding_rehab",
  label: "",
  options: [
    { label: "Driving Rehabilitation", value: "DrivingRehabilitation" },
    { label: "Riding Rehabilitation", value: "RidingRehabilitation" }
  ]
},

{ type: "subheading", label: "Assistive & Adaptive Devices" },
{
  type: "checkbox-group",
  name: "assistive_devices",
  label: "",
  options: [
    { label: "Splint", value: "Splint" },
    { label: "Pressure garment", value: "PressureGarment" },
    { label: "Tubular", value: "Tubular" },
    { label: "Manual wheelchair", value: "ManualWheelchair" },
    { label: "Lightweight wheelchair", value: "LightweightWheelchair" },
    { label: "Ultralight wheelchair", value: "UltralightWheelchair" },
    { label: "Motorised wheelchair", value: "MotorisedWheelchair" },
    { label: "Commode", value: "Commode" },
    { label: "Others", value: "AssistiveOthers" }
  ]
},
{
  type: "input",
  name: "assistive_devices_others",
  label: "Please specify",
  showIf: { field: "assistive_devices", includes: "AssistiveOthers" }
},

{ type: "subheading", label: "Treatment Plan: Therapeutic Exercise (Multiselect)" },
{
  type: "checkbox-group",
  name: "therapeutic_exercise",
  label: "",
  options: [
    { label: "Functional ROM", value: "FunctionalROM" },
    { label: "Fine Motor Training", value: "FineMotorTraining" },
    { label: "Stump Management Station", value: "StumpManagement" },
    { label: "Functional Mobility", value: "FunctionalMobility" },
    { label: "Sensory Desensitization", value: "SensoryDesensitization" }
  ]
}
      ]
    }
  ]
};

  const TREATMENT_PLAN_LABEL_MAP = {
    bed_mobility: "Bed mobility training",
    transfer: "Transfer training",
    MTM: "Muscle tone management",
    SBT: "Sitting balance training",
    StBT: "Standing balance training",
    FRE: "Functional ROM Exercise",
    strength: "Functional strengthening exercise",
    endurance: "Endurance training",
    FT: "Functional training",
    gait: "Gait training",
    WAP: "Walking aid prescription",
    bobath: "Bobath / NDT",
    others: "Others"
  };

  /* ===================== UI ===================== */
  const schemaMap = {
    subjective: SUBJECTIVE_SCHEMA,
    objective: OBJECTIVE_SCHEMA,
    assessment: ASSESSMENT_SCHEMA,
    plan: PLAN_SCHEMA
  };

  const tabOrder = ["subjective", "objective", "assessment", "plan"];


  return (
    <div style={mainContent}>

      {/* ===== PATIENT INFORMATION CARD ===== */}
     
        <PatientCard patient={patient}/>
<CommonFormBuilder
  schema={CONSENT_AND_REFERRAL_SCHEMA}
  values={values}
  onChange={onChange}
/>

{/* ===== CONSENT MODAL ===== */}
{showConsentModal && values.consent_obtained && (
  <div style={modalOverlay}>
    <div style={modalBox}>

      {/* CLOSE */}
      <button
        style={modalClose}
        onClick={() => setShowConsentModal(false)}
      >
        ×
      </button>

      {/* BODY */}
      <div
        style={{
          maxHeight: "75vh",
          overflowY: "auto",
          paddingRight: 6
        }}
      >
      {values.consent_obtained === "dry_needling" && (
        <DryNeedling
          key={`dry-${values.dry_needling_consent?.submittedAt || "new"}`}
          patient={patient}
          initialValues={values.dry_needling_consent || {}}
          onBack={() => setShowConsentModal(false)}
          onValuesChange={(latest) => { dryNeedlingRef.current = latest; }}
          onSubmit={(consentValues) => {
            onChange("dry_needling_consent", {
              ...consentValues,
              submittedAt: new Date().toISOString(),
              saved: true,
              consent_type: "Dry Needling"
            });
            setShowConsentModal(false);
          }}
        />
      )}

      {values.consent_obtained === "wall_climbing" && (
        <WallClimbing
          key={`wall-${values.wall_climbing_consent?.submittedAt || "new"}`}
          patient={patient}
          initialValues={values.wall_climbing_consent || {}}
          onBack={() => setShowConsentModal(false)}
          onValuesChange={(latest) => { wallClimbingRef.current = latest; }}
          onSubmit={(consentValues) => {
            onChange("wall_climbing_consent", {
              ...consentValues,
              submittedAt: new Date().toISOString(),
              saved: true,
              consent_type: "Wall Climbing"
            });
            setShowConsentModal(false);
          }}
        />
      )}
      </div>

      {/* FOOTER */}
   <div style={{ textAlign: "right", marginTop: 16 }}>
 <button
    style={saveCloseBtn}
    onClick={() => {
      const consentType = values.consent_obtained?.trim();
      const liveValues =
        consentType === "dry_needling"   ? dryNeedlingRef.current
        : consentType === "wall_climbing" ? wallClimbingRef.current
        : {};

      if (consentType === "dry_needling") {
        onChange("dry_needling_consent", {
          ...liveValues,
          submittedAt: new Date().toISOString(),
          saved: true,
          consent_type: "Dry Needling"
        });
      } else if (consentType === "wall_climbing") {
        onChange("wall_climbing_consent", {
          ...liveValues,
          submittedAt: new Date().toISOString(),
          saved: true,
          consent_type: "Wall Climbing"
        });
      }
      setShowConsentModal(false);
    }}
  >
    Save & Close
  </button>
      </div>
    </div>
  </div>
)}

{/* ===== TABS ===== */}
<div style={tabBar}>
  {["subjective", "objective", "assessment", "plan"].map(tab => (
    <div
      key={tab}
      style={activeTab === tab ? tabActive : tabBtn}
      onClick={() => setActiveTab(tab)}
    >
      {tab.toUpperCase()}
    </div>
  ))}
</div>
      {/* ===== TAB CONTENT ===== */}
      <CommonFormBuilder
        schema={schemaMap[activeTab]}
        values={values}
        onChange={onChange}
        submitted={submitted}
        onAction={handleAction}
        assessmentRegistry={NEURO_ASSESSMENT_REGISTRY}
      >

        {/* 🔹 ADD MATRIX ONLY IN PLAN TAB */}
        {activeTab === "plan" &&
          Array.isArray(values.treatment_plan) &&
          values.treatment_plan.length > 0 && (

            <div style={{ marginTop: 20 }}>
              <h3>Treatment Plan Schedule</h3>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f1f5f9" }}>
                    <th style={th}>Treatment</th>
                    <th style={th}>Frequency</th>
                    <th style={th}>Duration</th>
                  </tr>
                </thead>

                <tbody>
                  {values.treatment_plan.map(plan => (
                    <tr key={plan}>
                      <td style={td}>
                        <b>{TREATMENT_PLAN_LABEL_MAP[plan] || plan}</b>
                      </td>


                      <td style={td}>
                        <input
                          type="text"
                          placeholder="e.g. 5 days/week"
                          value={values[`freq_${plan}`] || ""}
                          onChange={e =>
                            onChange(`freq_${plan}`, e.target.value)
                          }
                        />
                      </td>

                      <td style={td}>
                        <input
                          type="text"
                          placeholder="e.g. 30 mins / 6 weeks"
                          value={values[`dur_${plan}`] || ""}
                          onChange={e =>
                            onChange(`dur_${plan}`, e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        <div style={submitRow}>
          {activeTab !== "plan" ? (
            <button
              style={submitBtn}
              onClick={() => {
                const idx = tabOrder.indexOf(activeTab);
                const next = tabOrder[Math.min(tabOrder.length - 1, idx + 1)];
                setActiveTab(next);
              }}
            >
              Next
            </button>
          ) : (
            <button style={submitBtn} onClick={handleSubmit}>
              Submit Amputee Assessment
            </button>
          )}
        </div>

      </CommonFormBuilder>


    </div>
  );
}

/* ===================== STYLES ===================== */
const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.55)",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20
};

const modalBox = {
  background: "#fff",
  width: "95%",
  maxWidth: 1100,
  maxHeight: "92vh",
  borderRadius: 14,
  padding: 24,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 20px 50px rgba(0,0,0,0.25)"
};

const modalClose = {
  position: "absolute",
  top: 1,
  right: 4,
  border: "none",
  background: "#ef4444",
  color: "#fff",
  width: 29,
  height: 30,
  borderRadius: "50%",
  cursor: "pointer",
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
};

const saveCloseBtn = {
  padding: "10px 18px",
  border: "none",
  borderRadius: 8,
  background: "#2563eb",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer"
};

const savedBtn = {
  padding: "10px 14px",
  borderRadius: 8,
  border: "1px solid #2563eb",
  background: "#eff6ff",
  color: "#2563eb",
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
  whiteSpace: "nowrap"
};

const mainContent = { margin: "0 auto" };

const tabBar = {
  display: "flex",
  gap: 12,
  justifyContent: "center",
  borderBottom: "1px solid #ddd",
  marginBottom: 12
};
const section = {
  marginBottom: 24
};

const sectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 12,
  borderBottom: "1px solid #e5e7eb",
  paddingBottom: 6,
  color: "#0F172A"
};

const patientGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 12,
  fontSize: 14
};

const tabBtn = {
  padding: "10px 22px",
  fontWeight: 600,
  cursor: "pointer",
  color: "#0f172a"
};

const tabActive = {
  ...tabBtn,
  borderBottom: "3px solid #2451b3",
  color: "#2451b3"
};

const submitRow = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 20
};

const submitBtn = {
  padding: "12px 32px",
  background: "#2563EB",
  color: "#fff",
  border: "none",
  borderRadius: 10,
  fontSize: 15,
  fontWeight: 700
};
const th = {
  border: "1px solid #ccc",
  padding: 10,
  textAlign: "left"
};

const td = {
  border: "1px solid #ccc",
  padding: 10
};